
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import EntryDetailPage from './pages/EntryDetailPage';
import EntryLocationPage from './pages/EntryLocationPage';
import AddLocationPage from './pages/AddLocationPage';
import EntryListPage from './pages/EntryListPage';
import EquipmentListPage from './pages/EquipmentListPage';
import WorkRecordListPage from './pages/WorkRecordListPage';
import WorkerListPage from './pages/WorkerListPage';
import ProjectListPage from './pages/ProjectListPage';
import TodaysSchedulePage from './pages/TodaysSchedulePage';
import RealTimePage from './pages/RealTimePage/RealTimePage';
import AlertSettingPage from './pages/AlertSettingPage';
import WorkRecordDetailPage from './pages/WorkRecordDetailPage';
import AddWorkerPage from './pages/AddWorkerPage';
import AddEquipmentPage from './pages/AddEqulpmentPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import WorkerDetailPage from './pages/WorkerDetailPage';
import WorkSchedulePage from './pages/WorkSchedulePage';
import AddProjectPage from './pages/AddProjectPage';
import AddWorkSchedulePage from './pages/AddWorkSchedulePage';
import SafetyMonitoringPage from './pages/SafetyMonitoringPage';
import ContractDetailPage from './pages/ContractDetailPage';
import LoginPage from './pages/LoginPage';
import EquipmentDetailPage from './pages/EquipmentDetailPage';
import DashboardPage from './pages/DashboardPage';
import ContractListPage from './pages/ContractListPage';
import AddContractPage from './pages/AddContractPage';
import EditContractPage from './pages/EditContractPage';
import { useEffect, useState } from 'react';
import { GlobalStateContext } from './store/GlobalState';
import CompanyListPage from './pages/CompanyListPage';
import AddCompanyPage from './pages/AddCompanyPage';
import CompanyDetailPage from './pages/CompanyDetailPage';
import AlertListingPage from './pages/AlertListingPage';
import ReportingListPage from './pages/ReportingListPage';
import ReportingDetailPage from './pages/ReportingDetailPage';
import InternalReportingListPage from './pages/InternalReportingListPage';
import InternalReportingDetailPage from './pages/InternalReportingDetailPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import { useSelector } from 'react-redux';
import { selectPermissions } from './features/auth/authSlice';
import UserListPage from './pages/UserListPage';
import UserDetailPage from './pages/UserDetailPage';
import AddUserPage from './pages/AddUserPage';
import UserRegistrationRequestDetailPage from './pages/UserRegistrationRequestDetailPage';
import { Permissions } from './utils/Permissions'
import WorkScheduleRecordPage from './pages/WorkScheduleRecordPage';
import WorkPermitPage from './pages/WorkPermitPage';
import RiskAssessmentPage from './pages/RiskAssessmentPage';


function App() {
  const [refreshToken, setRefreshToken] = useState("")
  const [accessToken, setAccessToken] = useState("")
  const [expires, setExpires] = useState("")
  const [user, setUser] = useState("")

  let globalState = {
    refreshToken: refreshToken,
    setRefreshToken: setRefreshToken,
    accessToken: accessToken,
    setAccessToken: setAccessToken,
    expires: expires,
    setExpires: setExpires,
    user: user,
    setUser: setUser,
  }

  const isLoggedIn = localStorage.accessToken || globalState.accessToken;

  const permissions = useSelector(selectPermissions)

  return (
    <GlobalStateContext.Provider value={globalState}>
      {/* <Router> */}

      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/reset-password" element={<LoginPage />} />
        {isLoggedIn && (
          <>
            <Route path="/change-password" element={<ChangePasswordPage />} />
            <Route path="/schedule" element={<TodaysSchedulePage />} />
            <Route path="/real-time" element={<RealTimePage />} />
            <Route path="/entry" element={<EntryListPage />} />
            <Route path="/entry-detail" element={<EntryDetailPage />} />
            {/* <Route path="/entry-location" element={<EntryLocationPage />} /> */}
            <Route path="/add-location" element={<AddLocationPage />} />
            {permissions.includes(Permissions.EquipmentView) && <Route path="/equipment" element={<EquipmentListPage />} />}
            {permissions.includes(Permissions.EquipmentEdit) && <Route path="/add-equipment" element={<AddEquipmentPage />} />}
            {permissions.includes(Permissions.EquipmentView) && <Route path="/equipment-detail" element={<EquipmentDetailPage />} />}
            <Route path="/work" element={<WorkRecordListPage />} />
            <Route path="/work-detail" element={<WorkRecordDetailPage />} />
            {permissions.includes(Permissions.WorkerView) && <Route path="/worker" element={<WorkerListPage />} />}
            {permissions.includes(Permissions.WorkerView) && <Route path="/worker-detail" element={<WorkerDetailPage />} />}
            {permissions.includes(Permissions.WorkerEdit) && <Route path="/add-worker" element={<AddWorkerPage />} />}
            {permissions.includes(Permissions.ProjectView) && <Route path="/project" element={<ProjectListPage />} />}
            {permissions.includes(Permissions.ProjectView) && <Route path="/project-detail" element={<ProjectDetailPage />} />}
            {permissions.includes(Permissions.ProjectEdit) && <Route path="/add-project" element={<AddProjectPage />} />}
            {permissions.includes(Permissions.EntryView) && <Route path="/work-schedule" element={<WorkSchedulePage />} />}
            {permissions.includes(Permissions.EntryView) && <Route path="/work-permit" element={<WorkPermitPage />} />}
            {permissions.includes(Permissions.EntryView) && <Route path="/risk-assessment" element={<RiskAssessmentPage />} />}
            {permissions.includes(Permissions.EntryEdit) && <Route path="/add-work-schedule" element={<AddWorkSchedulePage />} />}
            {permissions.includes(Permissions.EntryView) && <Route path="/work-schedule/record/:path" element={<WorkScheduleRecordPage />} />}
            <Route path="/alert" element={<AlertSettingPage />} />
            {permissions.includes(Permissions.EntryView) && <Route path="/safety-monitoring" element={<SafetyMonitoringPage />} />}
            {permissions.includes(Permissions.ContractView) && <Route path="/contract" element={<ContractListPage />} />}
            {permissions.includes(Permissions.ContractView) && <Route path="/contract-detail" element={<ContractDetailPage />} />}
            {permissions.includes(Permissions.ContractEdit) && <Route path="/add-contract" element={<AddContractPage />} />}
            {permissions.includes(Permissions.ContractEdit) && <Route path="/edit-contract" element={<EditContractPage />} />}
            <Route path="/dashboard" element={<DashboardPage />} />
            {permissions.includes(Permissions.CompanyView) && <Route path="/company" element={<CompanyListPage />} />}
            {permissions.includes(Permissions.CompanyEdit) && <Route path="/add-company" element={<AddCompanyPage />} />}
            {permissions.includes(Permissions.CompanyView) && <Route path="/company-detail" element={<CompanyDetailPage />} />}
            {permissions.includes(Permissions.PersonalAlertView) && <Route path="/alert-listing" element={<AlertListingPage />} />}
            {permissions.includes(Permissions.MonthlyReportView) && <Route path="/report" element={<ReportingListPage />} />}
            {permissions.includes(Permissions.MonthlyReportView) && <Route path="/report-detail" element={<ReportingDetailPage />} />}
            {permissions.includes(Permissions.ReportView) && <Route path="/internal-report" element={<InternalReportingListPage />} />}
            {permissions.includes(Permissions.ReportView) && <Route path="/internal-report-detail" element={<InternalReportingDetailPage />} />}
            {permissions.includes(Permissions.UserView) && <Route path="/user" element={<UserListPage />} />}
            {permissions.includes(Permissions.UserEdit) && <Route path="/add-user" element={<AddUserPage />} />}
            {permissions.includes(Permissions.UserView) && <Route path="/user-detail" element={<UserDetailPage />} />}
            {permissions.includes(Permissions.UserView) && <Route path="/user-registration-request-detail" element={<UserRegistrationRequestDetailPage />} />}
          </>)//ReportingListPage
          //   : (
          //   <Navigate to="/" replace /> // Redirect unauthorized users to the login page
          // )
        }
      </Routes>
      {/* </Router> */}
    </GlobalStateContext.Provider>
  );
}

export default App;
